import { App, AppVersion, VersionStatus } from '~/use-cases/types/Version';
import { Gateway } from './base/gateway';
import { fullStackNetworkManager } from './network/fullStackNetworkManager';
import { MagicRequest, RequestMethod } from './network/magicRequest';

const VERSIONS_URL = '/api/public/versions/web';

interface ClientVersionJson {
  app?: string;
  appVersion?: string;
  status?: string;
}

const VERSION_STATUSES = new Set<string>(Object.values(VersionStatus));

class VersionGateway extends Gateway {
  public async getVersion(): Promise<AppVersion | undefined> {
    const request: MagicRequest = {
      url: VERSIONS_URL,
      method: RequestMethod.GET,
      headers: this.createCommonHeaders(),
    };
    const response = await this.sendRequest(request);
    const json: ClientVersionJson[] = await response.json();
    const version = json.find((entry) => entry.app === App.CompanyWeb);
    if (!version) {
      return undefined;
    }
    return {
      appVersion: version.appVersion,
      status: version.status && VERSION_STATUSES.has(version.status) ? (version.status as VersionStatus) : undefined,
    };
  }
}

export const versionGateway = new VersionGateway(fullStackNetworkManager);
